import {Card, Spin, Typography} from "antd";
import React, {useEffect} from "react";
import Plural from "../../components/Plural";
import CalculationTolerances from "../outputs/CalculationTolerances";
import EmptyLine from "../outputs/EmptyLine";

export default function InternalSummaryPanel({summary, report, calculation_tolerances}) {
    const fontFamily = report ? 'Calibri' : 'Segoe ui'
    const fontSize = report ? '11pt' : '9pt'

    return (
        <div style={{fontFamily, fontSize}}>
            {summary?.length} feet ({(summary?.length / 5280).toFixed(2)} miles) reach
            <Plural
                count={summary?.crossSections}
                singular={'cross section'}
                plural={'cross sections'}
                render={(count, text) => (
                    <>
                        <br/>
                        {count} {text}
                    </>
                )}
            />
            <Plural
                count={summary?.single_bridge}
                singular={'(single opening) bridge'}
                plural={'(single opening) bridges'}
                render={(count, text) => {
                    return (
                        <>
                            <br/>
                            {count} {text}
                        </>
                    )
                }}
            />
            <Plural
                count={summary?.multiple_bridge}
                singular={'multiple openings'}
                plural={'multiple openings'}
                render={(count, text) => {
                    return (
                        <>
                            <br/>
                            {count} {text}
                        </>
                    )
                }}
            />
            <Plural
                count={summary?.culverts}
                singular={'culvert'}
                plural={'culverts'}
                render={(count, text) => {
                    return (
                        <>
                            <br/>
                            {count} {text}
                        </>
                    )
                }}
            />
            <Plural
                count={summary?.inline}
                singular={'inline structure'}
                plural={'inline structures'}
                render={(count, text) => {
                    return (
                        <>
                            <br/>
                            {count} {text}
                        </>
                    )
                }}
            />
            <Plural
                count={summary?.profiles}
                singular={'profile'}
                plural={'profiles'}
                render={(count, text) => (
                    <>
                        <br/>
                        {count} {text}
                        <Plural
                            count={summary?.flowLocations}
                            singular={'location'}
                            plural={'locations'}
                            render={(count, text) => {
                                return ` with ${count} flow change ${text}`
                            }}
                        />
                    </>
                )}
            />

            <EmptyLine height={16}/>
            <CalculationTolerances calculation_tolerances={calculation_tolerances}/>
        </div>
    )
}